module.exports = __webpack_public_path__ + "img/racecourse-fairview-poly-1900.e4511668.svg";